"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentAdapterEvents = void 0;
class ContentAdapterEvents {
    constructor(messageBroker) {
        this.messageBroker = messageBroker;
    }
    get playerSegmentation() {
        return this.messageBroker.player.topics.b2cPlayerSegmentation;
    }
}
exports.ContentAdapterEvents = ContentAdapterEvents;
//# sourceMappingURL=content-adapter.interface.js.map